import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { decodeJWT } from '../services/api';

const AUTH_KEYS = ['access_token', 'refresh_token', 'email', 'user', 'userType', 'username', 'redirected'];

/** True when this browser holds a sign-in that hasn't expired; an expired one is cleared. */
function hasActiveSession(): boolean {
  const token = localStorage.getItem('access_token');
  if (!token || token === 'undefined' || token === 'null') return false;
  try {
    const decoded: any = decodeJWT(token);
    if (decoded?.exp && decoded.exp * 1000 <= Date.now()) {
      AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
      return false;
    }
    return true;
  } catch {
    AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
    return false;
  }
}

/**
 * Wraps the login and sign-up pages: someone already signed in goes to the
 * exchange home instead of a sign-up form they can't complete. ?action=Logout
 * is let through so signing out keeps working.
 */
const RedirectIfSignedIn = ({ children }: { children: React.ReactElement }) => {
  const location = useLocation();
  const loggingOut = new URLSearchParams(location.search).get('action') === 'Logout';
  if (!loggingOut && hasActiveSession()) return <Navigate to="/update/home/" replace />;
  return children;
};

export default RedirectIfSignedIn;
